import { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';
import InputHeightContainer from '~/pages/Mystery/Chat/InputHeightContainer';
import { TextBox } from '~/components/Chat';
import MsgReceiverPicker from '~/components/Chat/MissionGame/MsgReceiverPicker/MsgReceiverPicker';
import { MessageResponse } from '~/types';
import { ChatRoomMemberData } from '~/types/missionGameApi';
import { breakpoint } from '~/styles/themes';
import '~/store';
import { useCommonChatStore, useUserStore } from '~/store';
import ChatContent from './ChatContent';

interface ChatProps {
  webSocket: React.RefObject<WebSocket>;
  messages: MessageResponse[];
  setMessages: React.Dispatch<React.SetStateAction<MessageResponse[]>>;
  waitingChat: boolean;
  handleSetWaitingChatTrue: () => void;
  avatars?: ChatRoomMemberData[];
}

export default function Chat({
  webSocket,
  messages,
  setMessages,
  waitingChat,
  handleSetWaitingChatTrue,
  avatars,
}: ChatProps) {
  const isMultiAvatarGame = !!(avatars && avatars?.length > 1);
  const { id: chatroomId } = useParams();
  const room_type = useCommonChatStore((state) => state.roomType);
  const gameChatRoomId =
    useCommonChatStore((state) => state.missionGame?.game_chat_id) ?? '';
  const members = useCommonChatStore((state) => state.chatMembers);
  const email = useUserStore((state) => state.email);

  const senderAIName = members
    .filter((member) => member.id !== email)
    .filter((member) => messages[messages.length - 1].id === member.id)
    .map((member) => member.name)
    .join(', ');

  const [showTextBox, setShowTextBox] = useState<boolean>(false);
  const [selectedCharacterId, setSelectedCharacterId] = useState<string>(
    avatars?.[0]?.id ?? '',
  );

  return (
    <Container>
      <Inner>
        <ChatContent
          name={senderAIName}
          messages={messages}
          waitingChat={waitingChat}
          showTextBox={showTextBox}
          setShowTextBox={setShowTextBox}
        />
        <InputHeightContainer hasMsgReceiverPicker={isMultiAvatarGame}>
          {isMultiAvatarGame && (
            <MsgReceiverPicker
              avatars={avatars || null}
              setSelectedCharacter={setSelectedCharacterId}
              selectedCharacterId={selectedCharacterId}
              showReceiverPicker={showTextBox}
            />
          )}
          {/* 채팅 입력 컴포넌트 */}
          <TextBox
            webSocket={webSocket}
            chatroomId={
              room_type === 'mission'
                ? gameChatRoomId.toString()
                : chatroomId || ''
            }
            setWaitingChatTrue={handleSetWaitingChatTrue}
            setMessages={setMessages}
            room_type={room_type ? room_type : 'user'}
            showTextBox={showTextBox}
            setShowTextBox={setShowTextBox}
            receiverCharacterId={selectedCharacterId}
          />
        </InputHeightContainer>
      </Inner>
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  position: absolute;
  z-index: 5;
  bottom: 0;
  left: 0;
  flex-direction: column;
  overflow: hidden;
  transition: height 0.1s ease-in-out;
`;

export const Inner = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  left: 50%;
  flex-direction: column;
  width: 100%;
  max-width: ${breakpoint.mobile_large};
  padding: 8px;
  transform: translateX(-50%);
  gap: 8px;
`;
